import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "./../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../includes/Heading.js";
const Container = tw.div`relative`;
const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const Content = tw.div`mt-16`;
const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default class ServiceList extends React.Component {

  cards = [];
  title = '';

  constructor(props) {
    super(props);
    this.cards = props.listData;
    this.title = props.fieldData.title;
  }

  render() {
    return (
        <Container className="services-page">
          <SingleColumn>
            <HeadingInfoContainer>
              <HeadingTitle>{this.title}</HeadingTitle>
            </HeadingInfoContainer>
            <Content>
              {this.cards.map((card, i) => (
                  <Card key={i} reversed={i % 2 === 1}>
                    <img src={card.image}  alt=""/>
                    <Details>
                      <Title>{card.title}</Title>
                      <Description>{card.detail}</Description>
                    </Details>
                  </Card>
              ))}
            </Content>
          </SingleColumn>
          <SvgDotPattern1 />
          <SvgDotPattern2 />
          <SvgDotPattern3 />
          <SvgDotPattern4 />
        </Container>
    );
  }
}

